import React from 'react';
import styles from './index.module.less';
import { TActivityStatus } from 'base/utils/flashsale'
import cn from 'classnames';
import { useTrans } from 'base/utils/i18n'
import { IProduct } from 'mod/product/interface';

type IProps = {
    className?: string;
    status: TActivityStatus;
    variant: IProduct;
    title: string;
}

const ProductName: React.FC<IProps> = (props) => {
    const {
        className, status, variant, title
    } = props
    const { t } = useTrans();

    return(
        <p className={cn(styles.name, className, 'g-product-name')}>
            {
                status === 'notStarted'
                    ? t('web_home_sfs_preview_name')
                    : (title || variant.title)
            }
        </p>
    );
};

export default ProductName